import { render, staticRenderFns } from "./WorkshopDetailView.vue?vue&type=template&id=557c601a&"
import script from "./WorkshopDetailView.vue?vue&type=script&lang=ts&"
export * from "./WorkshopDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports